import React, { useState } from "react";
import makeStyles from "@mui/styles/makeStyles";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import { Trans } from "react-i18next";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { SelectSubjectDialog } from "./SubjectSelector";
import { usePictureSets } from "@/react/Webshop/hooks/usePictureSets";
import AddSubjectDialog from "@/react/Webshop/Mobile/Components/AddSubjectDialog";
import { Link } from "react-router-dom";
import { generatePath } from "react-router";
import useMobileRoutes from "@/react/Webshop/Mobile/hooks/useMobileRoutes";
const useStyles = makeStyles((theme) => ({
    container: {
        color: theme.palette.primary.dark,
        backgroundColor: theme.palette.primary.light,
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        display: "flex",
        justifyContent: "center",
    },
    subjectName: {},
    subjectGroup: {
        fontStyle: "italic",
        fontSize: "12px",
    },
    changePictureSetContainer: {
        backgroundColor: "transparent",
        color: theme.palette.primary.main,
        border: "2px solid " + theme.palette.primary.main,
        marginRight: theme.spacing(2),
        borderRadius: theme.spacing(1),
        display: "flex",
        alignItems: "center",
        padding: theme.spacing(1),
    },
    avatarContainer: {
        width: "43px",
        height: "43px",
        border: "1px solid " + theme.palette.primary.main,
        borderRadius: "4px",
        marginRight: theme.spacing(1),
        "& > img": {
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "center 10%",
        },
    },
    singleAvatarContainer: {
        width: "54px",
        height: "54px",
        marginRight: theme.spacing(2),
    },
    viewSetText: {
        fontSize: "12px",
        color: theme.palette.primary.main,
        textTransform: "uppercase",
    },
}));
const SubjectSelect = ({ pictureSet }) => {
    const classes = useStyles();
    const [showSubjectSelector, setShowSubjectSelector] = useState(false);
    const { pictureSets: pictureSets } = usePictureSets();
    const [showAddPictureSetDialog, setShowAddPictureSetDialog] = useState(false);
    const routes = useMobileRoutes();
    const handleAddPictureSet = () => {
        setShowAddPictureSetDialog(true);
        setShowSubjectSelector(false);
    };
    const singleSubjectSet = pictureSets && pictureSets.length === 1;
    return (React.createElement(Box, { className: classes.container },
        React.createElement(Box, null,
            React.createElement(Box, { display: "flex" },
                singleSubjectSet && (React.createElement(Box, { className: `${classes.avatarContainer} ${classes.singleAvatarContainer}` },
                    React.createElement("img", { src: pictureSet.avatar.url }))),
                !singleSubjectSet && (React.createElement("button", { className: classes.changePictureSetContainer, onClick: () => setShowSubjectSelector(true) },
                    React.createElement(Box, { className: classes.avatarContainer },
                        React.createElement("img", { src: pictureSet.avatar.url })),
                    React.createElement(ExpandMore, null))),
                React.createElement(Box, null,
                    React.createElement(Box, { className: classes.subjectName }, pictureSet.subject.name),
                    React.createElement(Box, { className: classes.subjectGroup }, pictureSet.subject.group),
                    React.createElement(Divider, null),
                    React.createElement(Box, { className: classes.viewSetText, "data-testid": "view-picture-set-container" },
                        React.createElement(Link, { to: generatePath(routes["myaccount.picturesets.pictureset"].path, { uuid: pictureSet.uuid }) }, pictureSet.isEditable ? (React.createElement(Trans, null, "View and edit picture set")) : (React.createElement(Trans, null, "View picture set")))))),
            showAddPictureSetDialog && (React.createElement(AddSubjectDialog, { onClose: () => setShowAddPictureSetDialog(false) })),
            showSubjectSelector && (React.createElement(SelectSubjectDialog, { onClose: () => setShowSubjectSelector(false), pictureSets: pictureSets, handleAddPictureSet: handleAddPictureSet })))));
};
export default SubjectSelect;
